import React, { PureComponent } from 'react'
import T from 'prop-types'
// import _ from 'lodash'
import IT from 'react-immutable-proptypes'
import {
  // TextInput,
  ScrollBars,
  // CircleLoader,
  AnimateHeight,
  SaveButton,
  ErrorState,
  DataTable,
  // Button
  DimensionAware,
  TextOverflowCenterLite
} from 'react-base'
import {
  is,
  Map,
  List,
  OrderedMap,
  Iterable
} from 'immutable'
import Schema from '../Schema'
import {
  SCHEMA_ITEM_SHAPE,
  SCHEMA_SHAPE
} from '../shapes'
import memoize from 'memoize-one'
import Input from '../form/Input'

export default class Cell extends PureComponent {
  static propTypes = {
    schema: SCHEMA_SHAPE.isRequired,
    row: IT.map.isRequired,
    columnKey: T.oneOfType([T.string, T.number]).isRequired,
    rowIndex: T.number,
    column: SCHEMA_ITEM_SHAPE,

    readOnly: T.bool,
    onChange: T.func,
    onValidationChange: T.func,
    onFocus: T.func,
    onBlur: T.func
  }

  handleFocus = () => {
    const {
      onFocus,
      columnKey,
      rowIndex
    } = this.props
    onFocus(rowIndex, columnKey)
  }

  handleBlur = () => {
    const {
      onBlur,
      columnKey,
      rowIndex
    } = this.props
    onBlur(rowIndex, columnKey)
  }

  handleChange = (newVal) => {
    console.log('input change', newVal)
    const {
      onChange,
      columnKey,
      rowIndex
    } = this.props
    onChange(rowIndex, columnKey, newVal)
  }

  handleValidationChange = (a) => {
    // console.log('input handle validationchange', a)

  }

  handleNestedRowChange = (nestedRowIndex, nestedColumnKey, val) => {}
  handleNestedRowValidationChange = (nestedRowIndex, nestedColumnKey, val) => {}
  handleNestedRowFocus = (nestedRowIndex, nestedColumnKey) => {}
  handleNestedRowBlur = (nestedRowIndex, nestedColumnKey) => {}

  _renderNestedRow = memoize((
    nestedRow,
    nestedColumns,
    nestedSchema,
    nestedRowIndex=0,
    readOnly
  ) => {
    return (
      <div className={`nested_row ${nestedRowIndex % 2 ? 'odd_row' : 'even_row'}`}>
        {nestedColumns.entrySeq().map(([nestedColumnKey, nestedColumn]) => {
          return (
            <div
              key={nestedColumnKey}
              className={`schemer_cell_nested`}
              style={{
                width: nestedColumn.get('width')
              }}
            >
              <Cell
                column={nestedColumn}
                columnKey={nestedColumnKey}
                row={nestedRow}
                schema={nestedSchema}
                readOnly={readOnly}
                onChange={this.handleNestedRowChange}
                onValidationChange={this.handleNestedRowValidationChange}
                onFocus={this.handleNestedRowFocus}
                onBlur={this.handleNestedRowBlur}
              />
            </div>
          )
        })}
      </div>
    )
  })

  render() {
    const {
      column,
      row,
      columnKey,
      schema,
      readOnly,
      onFocus,
      onBlur
    } = this.props

    const rawDatum = row.get(columnKey)
    let datum = rawDatum
    const schemaDef = schema.get(columnKey)
    const hasNestedColumns = column.has('columns')

    if (hasNestedColumns) {
      const nestedCols = column.get('columns')
      const nestedSchema = schemaDef.get('schema')
      if (Iterable.isKeyed(datum)) {
        // Single Nested Object structure?
        datum = this._renderNestedRow(datum, nestedCols, nestedSchema, 0, readOnly)
      }
      else if (Iterable.isIndexed(datum)) {
        // Nested array of objects?
        datum = datum.entrySeq().map(([nestedRowIdx, nestedRow]) => {
          return (
            <div
              key={nestedRowIdx}
              className="nested_rows"
            >{this._renderNestedRow(nestedRow, nestedCols, nestedSchema, nestedRowIdx, readOnly)}</div>
          )
        })
      }
    }

    const formatter = column.get('formatDisplay', schemaDef.get('formatDisplay', null))
    let content = formatter ? formatter(datum, schemaDef, schema) : datum
    const isMultiline = column.getIn(['table', 'multiline'], false)

    if (content && content.toString) {
      content = content.toString()
    }

    return (
      <div
        className={`schemer_cell_content ${readOnly ? 'read_only' : 'editable'} ${hasNestedColumns ? 'has_nested_cols' : ''}`}
      >
        {!readOnly ? (
          <div>
            <Input
              fieldName={columnKey}
              field={schemaDef}
              schema={schema}
              onChange={this.handleChange}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              onValidationChange={this.handleValidationChange}
              readOnly={readOnly}
              currentValue={rawDatum}
              customInputs={null}
              fieldOptions={null}
              showLabel={false}
            />
          </div>
        ) : typeof content === 'string' && !isMultiline
          ? (
            <TextOverflowCenterLite
              value={content}
            />
          ) : content
        }
      </div>
    )
  }
}